import { useWizard } from 'react-use-wizard';
import { useEffect } from 'react';
function CountStep({
   products,
   designs,
   handleCountChange,
   handleEditProduct,
   handleDeleteProduct,
   handleAddNewProduct,
   handleCreateDesign,
   handleChangeDesignQuantity,
   handleCalculateProductsOnInit,
}) {
   const { previousStep, goToStep } = useWizard();

   useEffect(() => {
      if (products.length !== 0) {
         handleCalculateProductsOnInit();
      }
   }, []);

   const withoutDesignQuantity = product => {
      const quantity =
         product.sizes.filter(item => item.quantity > 0).reduce((acc, size) => acc + size.quantity, 0) -
         product.decorations
            .filter(decoration => decoration.group_id !== 0)
            .reduce((acc, size) => acc + size.quantity, 0);

      return quantity < 0 ? 0 : quantity;
   };

   const images = {
      edit: (
         <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2071_1592)">
               <path
                  d="M14.167 2.5009C14.3859 2.28203 14.6457 2.10842 14.9317 1.98996C15.2176 1.87151 15.5241 1.81055 15.8337 1.81055C16.1432 1.81055 16.4497 1.87151 16.7357 1.98996C17.0216 2.10842 17.2815 2.28203 17.5003 2.5009C17.7192 2.71977 17.8928 2.97961 18.0113 3.26558C18.1297 3.55154 18.1907 3.85804 18.1907 4.16757C18.1907 4.4771 18.1297 4.7836 18.0113 5.06956C17.8928 5.35553 17.7192 5.61537 17.5003 5.83424L6.25033 17.0842L1.66699 18.3342L2.91699 13.7509L14.167 2.5009Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
            <defs>
               <clipPath id="clip0_2071_1592">
                  <rect width="20" height="20" fill="white" />
               </clipPath>
            </defs>
         </svg>
      ),
      delete: (
         <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
               d="M3.31543 5.05273H4.99964H18.4733"
               stroke="currentColor"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M16.7895 5.05201V16.8415C16.7895 17.2882 16.612 17.7166 16.2962 18.0324C15.9803 18.3483 15.5519 18.5257 15.1053 18.5257H6.68421C6.23753 18.5257 5.80914 18.3483 5.49329 18.0324C5.17744 17.7166 5 17.2882 5 16.8415V5.05201M7.52632 5.05201V3.3678C7.52632 2.92112 7.70376 2.49274 8.01961 2.17689C8.33546 1.86104 8.76385 1.68359 9.21053 1.68359H12.5789C13.0256 1.68359 13.454 1.86104 13.7699 2.17689C14.0857 2.49274 14.2632 2.92112 14.2632 3.3678V5.05201"
               stroke="currentColor"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M9.20996 9.26367V14.3163"
               stroke="currentColor"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12.5781 9.26367V14.3163"
               stroke="currentColor"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </svg>
      ),
      cloth: (
         <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
               d="M20.7271 4.94253C20.7146 4.88728 20.6868 4.84308 20.6492 4.8173L14.4694 0.855862C14.4541 0.844812 14.4388 0.837445 14.4235 0.833762C14.4137 0.83192 14.404 0.830078 14.3929 0.830078H7.07094C7.04033 0.830078 7.01111 0.841128 6.98745 0.861387L0.817385 4.81546C0.779817 4.84308 0.751989 4.88728 0.739466 4.94069C0.726943 4.99594 0.731117 5.05303 0.751989 5.10276L2.67353 8.85432C2.69301 8.90404 2.7278 8.94088 2.76815 8.95745C2.78067 8.96297 2.79319 8.96482 2.8085 8.96482H2.81546H2.82102C2.82937 8.96482 2.83772 8.96297 2.84885 8.95929C2.85163 8.95929 2.85441 8.95929 2.8572 8.95745C2.86972 8.95377 2.88085 8.9464 2.89059 8.94088L4.91232 7.50988V20.6183C4.91232 20.7362 4.98467 20.8301 5.07233 20.8301H16.3929C16.4819 20.8301 16.5529 20.7343 16.5529 20.6183V7.50804L18.576 8.94088C18.5857 8.94824 18.5969 8.95377 18.6094 8.95745C18.6122 8.95745 18.615 8.95745 18.6205 8.96113C18.6289 8.96297 18.6372 8.96482 18.6456 8.96482H18.6511H18.6553C18.6706 8.96482 18.6845 8.96113 18.6971 8.95745C18.7374 8.94088 18.7722 8.90404 18.7917 8.85432L20.7132 5.10276C20.7327 5.05303 20.7383 4.9941 20.7257 4.94069L20.7271 4.94253Z"
               fill="#161617"
            />
         </svg>
      ),
      tape: (
         <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
               d="M19.9947 4.11245C19.9822 4.0572 19.9544 4.013 19.9168 3.98722L13.737 0.0257836C13.7217 0.0147335 13.7064 0.00736675 13.6911 0.00368338C13.6813 0.00184169 13.6716 0 13.6605 0H6.33852C6.3079 0 6.27869 0.0110501 6.25503 0.0313087L0.0849632 3.98538C0.047395 4.013 0.0195668 4.0572 0.00704403 4.11061C-0.00547869 4.16586 -0.00130445 4.22296 0.0195668 4.27268L1.94111 8.02424C1.96059 8.07396 1.99537 8.1108 2.03573 8.12737C2.04825 8.1329 2.06077 8.13474 2.07608 8.13474H2.08303H2.0886C2.09695 8.13474 2.1053 8.1329 2.11643 8.12921C2.11921 8.12921 2.12199 8.12921 2.12478 8.12737C2.1373 8.12369 2.14843 8.11632 2.15817 8.1108L4.17989 6.6798V19.7882C4.17989 19.9061 4.25225 20 4.33991 20H15.6605C15.7495 20 15.8205 19.9042 15.8205 19.7882V6.67796L17.8436 8.1108C17.8533 8.11816 17.8644 8.12369 17.877 8.12737C17.8798 8.12737 17.8825 8.12737 17.8881 8.13105C17.8965 8.1329 17.9048 8.13474 17.9132 8.13474H17.9187H17.9229C17.9382 8.13474 17.9521 8.13105 17.9646 8.12737C18.005 8.1108 18.0398 8.07396 18.0592 8.02424L19.9808 4.27268C20.0003 4.22296 20.0058 4.16402 19.9933 4.11061L19.9947 4.11245Z"
               fill="#161617"
            />
            <rect x="6.5" y="0.5" width="19" height="6" transform="rotate(90 6.5 0.5)" fill="white" stroke="black" />
            <path
               d="M6 5.20078L2.875 5.20078M6 10.0008L2.875 10.0008M6 14.8008L2.875 14.8008M6 17.2008L4.125 17.2008M6 12.4008L4.125 12.4008M6 7.60078L4.125 7.60078M6 2.80078L4.125 2.80078"
               stroke="black"
               strokeWidth="0.7"
            />
         </svg>
      ),
      calculator: (
         <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M2.25801 0H17.742H18.0635V0.0283095C19.0767 0.208338 19.8732 1.2268 19.9862 2.502H19.9996V2.76267C19.9999 2.77996 20 2.79729 20 2.81466C20 2.83203 19.9999 2.84936 19.9996 2.86666V20H11.9353H3.871V5.62932H2.25801H1.93485V5.60072C0.840873 5.40529 0 4.23238 0 2.81466C0 1.39694 0.840873 0.224033 1.93485 0.028609V0H2.25801Z"
               fill="#FDFDFD"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M19.9862 2.502C19.8732 1.2268 19.0767 0.208338 18.0635 0.0283095V0H1.93485V0.028609C0.840873 0.224033 0 1.39694 0 2.81466C0 4.23238 0.840873 5.40529 1.93485 5.60072V5.62932H3.871V20H19.9996V2.86666C19.9999 2.84936 20 2.83203 20 2.81466C20 2.79729 19.9999 2.77996 19.9996 2.76267V2.502H19.9862ZM19.3545 2.67993L19.3435 2.55557C19.2464 1.46057 18.5835 0.756599 17.9472 0.643544L17.8455 0.62548H2.15394L2.05175 0.643735C1.36451 0.766501 0.645145 1.5871 0.645145 2.81466C0.645145 4.04222 1.36451 4.86282 2.05175 4.98559L2.15394 5.00384H4.51614V19.3745H19.3545V2.85785L19.3549 2.81466L19.3545 2.77147L19.3544 2.76267L19.3545 2.67993Z"
               fill="black"
            />
            <path
               d="M4.51602 2.81466C4.51602 4.36916 3.50507 5.62933 2.25801 5.62933C1.01094 5.62933 0 4.36916 0 2.81466C0 1.26017 1.01094 0 2.25801 0C3.50507 0 4.51602 1.26017 4.51602 2.81466Z"
               fill="#FDFDFD"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M2.25801 5.00384C3.00727 5.00384 3.87087 4.17911 3.87087 2.81466C3.87087 1.45021 3.00727 0.625481 2.25801 0.625481C1.50874 0.625481 0.645145 1.45021 0.645145 2.81466C0.645145 4.17911 1.50874 5.00384 2.25801 5.00384ZM2.25801 5.62933C3.50507 5.62933 4.51602 4.36916 4.51602 2.81466C4.51602 1.26017 3.50507 0 2.25801 0C1.01094 0 0 1.26017 0 2.81466C0 4.36916 1.01094 5.62933 2.25801 5.62933Z"
               fill="black"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M3.87207 6.87836V2.5H4.51722V6.87836H3.87207Z"
               fill="black"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M17.3864 10.6855H6.41895V10.0601H17.3864V10.6855Z"
               fill="black"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M17.3864 13.8125H6.41895V13.187H17.3864V13.8125Z"
               fill="black"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M17.3864 7.57422L6.41895 7.57422V6.94874L17.3864 6.94874V7.57422Z"
               fill="black"
            />
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M17.3864 16.9395H6.41895V16.314H17.3864V16.9395Z"
               fill="black"
            />
         </svg>
      ),
   };

   const handleChangeSizeCount = (index, indexSize, value) => {
      if (value < 0) {
         return;
      }
      handleCountChange(index, indexSize, value);
   };
   const changeDesignQuantity = (product, index, designId, value) => {
      if (value < 0) {
         return;
      }
      const totalQuantity = product.sizes.reduce((acc, size) => acc + size.quantity, 0);
      const totalDecorationsQuantity = product.decorations
         .filter(item => item.group_id !== 0 && item.group_id !== designId)
         .reduce((acc, size) => acc + size.quantity, 0);
      if (+value + totalDecorationsQuantity <= totalQuantity) {
         handleChangeDesignQuantity(index, designId, value);
      }
      // handleChangeDesignQuantity(index, designId, value);
   };

   return (
      <div className="step">
         <div className="step__container">
            <div className="step__content">
               <div className="step__hint">Оберіть кількість виробів</div>

               <div className="step__products">
                  {products.map((product, index) => (
                     <div key={product.item_id + index} className="step__products-wrap-block">
                        <div className="step__product-wrap">
                           <div className="step__product">
                              <div className="step__product-rows">
                                 <div className="step__product-row">
                                    <div className="step__product-image">{images.cloth}</div>
                                    <p className="step__product-title">
                                       {product.data.productType.name} {product.data.fashionType.name},{' '}
                                       {product.data.clothType.name}, {product.data.color.name}
                                    </p>
                                    <div className="step__product-actions-mobile">
                                       <button
                                          onClick={() => handleEditProduct(index, goToStep)}
                                          className="step__product-action-btn"
                                       >
                                          {images.edit}
                                       </button>
                                       <button
                                          onClick={() => handleDeleteProduct(index)}
                                          className="step__product-action-btn"
                                       >
                                          {images.delete}
                                       </button>
                                    </div>
                                 </div>
                                 <div className="step__product-row">
                                    <div className="step__product-image">{images.tape}</div>

                                    <div className="step__product-sizes">
                                       {product.sizes
                                          .sort((a, b) => a.order - b.order)
                                          .map((size, indexSize) => (
                                             <div key={size.id} className="step__product-size">
                                                <div className="step__product-size-label">{size.size}</div>
                                                <div>
                                                   <input
                                                      type="number"
                                                      min="0"
                                                      className="step__product-size-input"
                                                      placeholder="0"
                                                      value={size.quantity}
                                                      onChange={event =>
                                                         handleChangeSizeCount(index, indexSize, event.target.value)
                                                      }
                                                   />
                                                </div>
                                             </div>
                                          ))}
                                    </div>
                                 </div>
                                 <div className="step__product-row">
                                    <div className="step__product-image">{images.calculator}</div>

                                    <div className="step__product-mobile-row-content">
                                       <p className="step__product-total-count">{product.quantity} шт.</p>
                                       <div className="step__product-total-price">
                                          {product.clothes_price || 0} <span>грн</span>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="step__product-actions">
                                 <div>
                                    <button
                                       onClick={() => handleEditProduct(index, goToStep)}
                                       className="step__product-action-btn"
                                    >
                                       {images.edit}
                                    </button>
                                    <button
                                       onClick={() => handleDeleteProduct(index)}
                                       className="step__product-action-btn"
                                    >
                                       {images.delete}
                                    </button>
                                 </div>
                                 <div className="step__product-total-price">
                                    {product.clothes_price || 0} <span>грн</span>
                                 </div>
                                 <p className="step__product-total-count">{product.quantity} шт.</p>
                              </div>
                           </div>

                           <div className={`step__product-design ${designs && designs.length ? 'available' : ''}`}>
                              {designs && designs.length ? (
                                 <div className="step__product-design-main">
                                    <div className="step__product-design-items">
                                       {designs.map(design => (
                                          <div key={index + design.id} className="step__product-design-item">
                                             <span>
                                                {design.id}. дизайн “{design.name}”
                                             </span>
                                             <input
                                                type="number"
                                                min="0"
                                                placeholder="0"
                                                value={
                                                   product.decorations.find(item => item.group_id === design.id)
                                                      ? product.decorations.find(item => item.group_id === design.id)
                                                           .quantity
                                                      : ''
                                                }
                                                onChange={event =>
                                                   changeDesignQuantity(product, index, design.id, +event.target.value)
                                                }
                                             />
                                          </div>
                                       ))}
                                    </div>
                                 </div>
                              ) : (
                                 <div className="step__product-design-main">Дизайн ще не створенно</div>
                              )}

                              <div className="step__product-design-total">
                                 <p>
                                    без дизайну >{' '}
                                    {withoutDesignQuantity(product)}{' '}
                                    шт
                                 </p>
                                 <p>
                                    з дизайном >{' '}
                                    {product.decorations
                                       .filter(decoration => decoration.group_id !== 0)
                                       .reduce((acc, size) => acc + size.quantity, 0)}{' '}
                                    шт
                                 </p>
                                 <div className="step__product-total-price">
                                    {product.decorations_price} <span>грн.</span>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="step__product-captions">
                           <p className="step__product-caption">[введіть кількість виробу, на кожний розмір]</p>
                           <p className="step__product-errors">{product.error}</p>
                        </div>
                     </div>
                  ))}
               </div>

               <div className="step__main-actions">
                  <button className="step__main-action" onClick={() => handleAddNewProduct(goToStep)}>
                     <span>додайте товар</span>
                     <div>+</div>
                  </button>
                  <button className="step__main-action" onClick={() => handleCreateDesign(goToStep)}>
                     <span>створити дизайн</span>
                     <div>+</div>
                  </button>
               </div>
            </div>
         </div>
         <div className="step__navigation">
            <button className="step__navigation-item" disabled={true} onClick={() => previousStep()}>
               назад
            </button>
            <button
               className="step__navigation-item"
               disabled={products.some(product => product.quantity === 0 || product.error)}
               onClick={() => goToStep(6)}
            >
               далі
            </button>
         </div>
      </div>
   );
}

export default CountStep;
